(function() {
  function initProcesoCompra(root) {
    if (!root || root.dataset.procesoCompraInitialized === 'true') return;

    root.dataset.procesoCompraInitialized = 'true';

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-process-step]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-process-panel]'));
    var progressText = root.querySelector('[data-progress-text]');
    var activeIndex = parseInt(root.getAttribute('data-active-step') || '0', 10);
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (!steps.length || !panels.length) return;

    function getProgress(index) {
      if (steps.length <= 1) return 100;
      return Math.round((index / (steps.length - 1)) * 100);
    }

    function setActiveStep(index) {
      if (index < 0 || index >= steps.length) return;

      activeIndex = index;
      root.setAttribute('data-active-step', String(index));

      var progress = getProgress(index);

      root.style.setProperty('--pci-progress', progress + '%');

      if (progressText) {
        progressText.textContent = progress + '%';
      }

      steps.forEach(function(step, stepIndex) {
        var isActive = stepIndex === index;

        step.classList.toggle('is-active', isActive);
        step.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function(panel, panelIndex) {
        panel.classList.toggle('is-active', panelIndex === index);
      });
    }

    steps.forEach(function(step) {
      var index = parseInt(step.getAttribute('data-process-step'), 10);

      step.addEventListener('click', function(event) {
        event.preventDefault();
        setActiveStep(index);
      });

      step.addEventListener('mouseenter', function() {
        if (!canHover) return;
        setActiveStep(index);
      });

      step.addEventListener('focus', function() {
        if (!canHover) return;
        setActiveStep(index);
      });
    });

    setActiveStep(activeIndex);
  }

  function initAllProcesoCompra() {
    var roots = document.querySelectorAll('.js-proceso-compra');

    roots.forEach(function(root) {
      initProcesoCompra(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProcesoCompra);
  } else {
    initAllProcesoCompra();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var root = event.target.querySelector('.js-proceso-compra');

    if (root) {
      root.dataset.procesoCompraInitialized = 'false';
      initProcesoCompra(root);
    }
  });
})();